import { IBreadcrumbItem } from '@/widgets/CustomBreadcrumbs';
import { ITeacherAssignmentsCourse } from '@/entities/TeacherAssignment';
import { routerPath } from '@/shared/config/router';

interface GetBreadcrumbsParams {
  courseId?: string;
  intakeId?: string;
  selectedCourse?: ITeacherAssignmentsCourse | null;
}

export const getTeacherAssignmentsBreadcrumbs = ({
  courseId,
  intakeId,
  selectedCourse,
}: GetBreadcrumbsParams): IBreadcrumbItem[] => {
  const items: IBreadcrumbItem[] = [{ label: 'Assignments', href: routerPath.teacherAssignments }];

  if (courseId && selectedCourse) {
    const selectedIntake = selectedCourse.intakes.find((i) => String(i.id) === intakeId);
    const courseLabel = `${selectedCourse.title}${selectedIntake ? ` ${selectedIntake.title}` : ''}`;
    items.push({
      label: courseLabel,
    });
  }

  return items;
};
